export default __webpack_public_path__ + "adb48b1.png";